import { StateType } from '../../index';

export const eventsDataCalendarEventsSelector = (state: StateType) => state.getIn(['events', 'data', 'calendarEvents']);
export const eventsDataIsFetchingSelector = (state: StateType) => state.getIn(['events', 'data', 'isFetching']);
export const eventsDataIsFetchingOptionsSelector = (state: StateType) => state.getIn(['events', 'data', 'isFetchingOptions']);
export const eventsDataEventsOpenSelector = (state: StateType) => state.getIn(['events', 'data', 'eventsOpen']);
export const eventsDataLanguageOptionsSelector = (state: StateType) => state.getIn(['events', 'filter', 'languageOptions']);
